
import { defineComponent, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { TButton } from '@tencent/web-vbui';
import { i18n } from '@tencent/vb-web-base';
import { useGlobalState } from '../../store/carOwnerRight';
import { navigator } from '@tencent/vb-app-bridge';
import { baseMixins } from '@common/mixins/baseMixins';
export default defineComponent({
  name: 'RightState',
  components: {
    TButton,
  },
  setup() {
    const { getT } = i18n;
    const $t = getT();
    const { setTitle } = baseMixins();
    setTitle($t('我的专属礼遇'));
    const state = useGlobalState();
    const router = useRouter();
    const route = useRoute();
    const { brand, isElectricCar, loanAmount } = route.query;
    const detail = computed(() => state.value.detail);
    const { userStatus } = state.value;
    const goTeslaRightHome = () => {
      router.back();
      // router.replace({
      //   path: '/rightMy',
      //   query: {
      //     loanAmount: userStatus.loanAmount || loanAmount,
      //     overdue: userStatus.overdue ? '0' : '1',
      //     prepay: userStatus.prepay ? '0' : '1',
      //     writeOff: userStatus.writeOff ? '0' : '1',
      //     brand,
      //     isElectricCar,
      //   },
      // });
    };
    const goCoupon = () => {
      navigator.push({
        path: '/e/my/coupon.html',
      });
    };
    return {
      detail,
      goTeslaRightHome,
      goCoupon,
    };
  },
});
